import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadsTable, LeadColumn, LeadRow, FilterConfig, ServerSidePagination, ViewButtonTracking } from '../leads-table/leads-table';

@Component({
  selector: 'app-dropdown-table',
  standalone: true,
  imports: [CommonModule, LeadsTable],
  templateUrl: './dropdown-table.html',
  styleUrls: ['./dropdown-table.scss']
})
export class DropdownTable {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() isOpen: boolean = false;
  @Input() tableColumns: LeadColumn[] = [];
  @Input() tableData: LeadRow[] = [];
  @Input() filterConfig: FilterConfig = {}; // Nova input para configuração de filtros
  @Input() serverSidePagination?: ServerSidePagination;
  @Input() loading: boolean = false;
  @Input() emptyMessage: string = 'Nenhum dado encontrado';
  @Input() errorMessage: string = '';
  @Input() viewButtonTracking: ViewButtonTracking = {
    trackEvent: 'table_button_click',
    trackCategory: 'leads_table',
    trackLabel: 'view_lead'
  };

  @Output() toggle = new EventEmitter<boolean>();
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() viewLeadClick = new EventEmitter<LeadRow>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() filterChange = new EventEmitter<string[]>();
  @Output() dateRangeChange = new EventEmitter<{ start: string, end: string }>();
  @Output() clearAllFilters = new EventEmitter<void>();
  @Output() sortChange = new EventEmitter<{ field: string, order: 'ASC' | 'DESC' }>();

  onToggle(): void {
    this.isOpen = !this.isOpen;
    this.toggle.emit(this.isOpen);
  }

  onPageChange(page: number): void {
    this.pageChange.emit(page);
  }

  onPageSizeChange(pageSize: number): void {
    this.pageSizeChange.emit(pageSize);
  }

  onViewLead(lead: LeadRow): void {
    this.viewLeadClick.emit(lead);
  }

  onSearchChange(searchText: string): void {
    this.searchChange.emit(searchText);
  }

  onFilterChange(filters: string[]): void {
    this.filterChange.emit(filters);
  }

  onDateRangeChange(dateRange: { start: string, end: string }): void {
    this.dateRangeChange.emit(dateRange);
  }

  onClearAllFilters(): void {
    this.clearAllFilters.emit();
  }

  onSortChange(sort: { field: string, order: 'ASC' | 'DESC' }): void {
    this.sortChange.emit(sort);
  }
}
